import Vue from "vue";
import VueRouter from "vue-router";
import routes from "@/router/routes";
import { hasVacanCompanyId, NewCompaniesApiFunc, setAccessToken } from "@/api";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const getCompany: () => Promise<void> = async () => {
  const companyId = Vue.prototype.$auth.companyId as string;
  setAccessToken(Vue.prototype.$auth.accessToken);
  const res = await NewCompaniesApiFunc().getCompany(companyId);

  if (res.err != null && Vue.prototype.$handleApiError) {
    Vue.prototype.$handleApiError(res.err, getCompany);
    return;
  }
  Vue.prototype.$globalData.setCompany(res.data);
};

const fetchCompanies: () => Promise<void> = async () => {
  const companyId = Vue.prototype.$auth.companyId as string;
  setAccessToken(Vue.prototype.$auth.accessToken);
  const { data, err } = await NewCompaniesApiFunc().adminListCompanies(
    companyId
  );
  if (!err && data.list) {
    Vue.prototype.$globalData.companies = data.list;
  } else {
    Vue.prototype.$globalData.companies = [];
  }
};

const clearSelectedCompanyIdIfNeeded: (
  fullPath: string
) => Promise<void> = async (fullPath: string) => {
  if (fullPath.split("/").filter((e) => e.length > 0)[0] !== "admin") {
    return;
  }
  if (
    fullPath.includes("/gateways/") ||
    fullPath.includes("/sensors/") ||
    fullPath.includes("/tablets/")
  ) {
    return;
  }

  Vue.prototype.$auth.setCompanyId(undefined);
  Vue.prototype.$globalData.setCompany(undefined);
};

router.beforeEach(async (to, from, next) => {
  Vue.prototype.$error.clearAll();
  Vue.prototype.$auth.restore();

  const role: string | undefined = Vue.prototype.$auth.role;
  const isAuthed: boolean = Vue.prototype.$auth.isAuthed();
  const selectedCompanyId: string = Vue.prototype.$auth.companyId;
  if (isAuthed && selectedCompanyId) {
    await getCompany();
    await fetchCompanies();
  }

  if (to.matched.some((record) => record.meta.requiresAuth) && !isAuthed) {
    return next({ path: "/login", query: { redirect: to.fullPath } });
  }

  if (to.fullPath === "/") {
    return role === "admin"
      ? next({ path: "/admin/companies" })
      : next({ path: "/companies" });
  }
  await clearSelectedCompanyIdIfNeeded(to.fullPath);

  const canAccess: boolean = to.matched.every((record) => {
    if (!record.meta.canAccessRole) {
      return true;
    }

    // adminがcompanyのページにアクセスするときは、VACANCompanyIdを持つようにする
    const adminAccessToCompanyPage: boolean =
      role === "admin" && record.meta.canAccessRole.includes("company");
    if (adminAccessToCompanyPage && !hasVacanCompanyId()) {
      return false;
    }

    const canAccessRole: boolean = record.meta.canAccessRole.includes(role);
    return canAccessRole;
  });

  if (!canAccess) {
    next({ path: "/login", query: { redirect: to.fullPath } });
    return (Vue.prototype.$error.errMessage = "不正なアクセスです");
  }

  return next();
});

export default router;
